

// @material-ui/icons
//import PersonAdd from "@material-ui/icons/PersonAdd";
import Fingerprint from "@material-ui/icons/Fingerprint";
//import MonetizationOn from "@material-ui/icons/MonetizationOn";
import LockOpen from "@material-ui/icons/LockOpen";

import LockedOut from "../views/External/LockedOut";
import Login from "../views/External/Login";
import ResetPassword from "../views/External/ResetPassword";
import OTP from "../views/External/OTP";
import SetNewPassword from "../views/External/SetNewPassword";

const externalRoutes = [
    {
        path: "/login",
        name: "Login",
        short: "Login",
        icon: Fingerprint,
        component: Login
    },
    {
        path: "/lockedOut",
        name: "Locked Out",
        short: "Lock",
        icon: LockOpen,
        component: LockedOut
    },
    {
        path: "/otp",
        name: "Two Factor Authentication",
        short: "2FA",
        icon: Fingerprint,
        component: OTP
    },
    {
        path: "/requestReset",
        name: "Reset Password",
        short: "Reset",
        component: ResetPassword
    },
    {
        path: "/reset/:reset_id",
        name: "Set Password",
        short: "Set Password",
        component: SetNewPassword
    },
    //   {
    //     path: "/pages/register-page",
    //     name: "Register Page",
    //     short: "Register",
    //     mini: "RP",
    //     icon: PersonAdd,
    //     component: RegisterPage
    //   },
    //   {
    //     path: "/pages/login-page",
    //     name: "Login Page",
    //     short: "Login",
    //     mini: "LP",
    //     icon: Fingerprint,
    //     component: LoginPage
    //   },
    //   {
    //     path: "/pages/pricing-page",
    //     name: "Pricing Page",
    //     short: "Pricing",
    //     mini: "PP",
    //     icon: MonetizationOn,
    //     component: PricingPage
    //   },
    //   {
    //     path: "/pages/lock-screen-page",
    //     name: "Lock Screen Page",
    //     short: "Lock",
    //     mini: "LSP",
    //     icon: LockOpen,
    //     component: LockScreenPage
    //   },
    //   {
    //     redirect: true,
    //     path: "/pages",
    //     pathTo: "/pages/register-page",
    //     name: "Register Page"
    //   }
];

export default externalRoutes;
